module.exports = __webpack_public_path__ + "static/media/beep.d932c606.mp3";